import GaEvent from './GaEvent';

export default class SearchSubmittedGaEvent extends GaEvent {
  constructor() {
    super('search_submitted');
  }

  addQuery(query: string) {
    this.addParam('query', query);

    return this;
  }
}
